/* eslint prefer-promise-reject-errors: ["error", {"allowEmptyReject": true}] */

import { Auth } from 'aws-amplify';

const currentSession = () => {
  return Auth.currentSession()
    .then(session => {
      if (!session) {
        return Promise.reject(new Error('ra.notification.logged_out'));
      }

      return session;
    })
    .catch(_ => {
      return Promise.reject();
    });
};

export default currentSession;
